export class DvirQuestionValueProviderDto {
  type: string;
  config: string;
  defaultValue?: string;
}
